import { ISelectOption } from '@smartshell/ui-kit';

import { ELauncher } from 'types';

import { ICONS } from './constants';
import s from './ManageGameAccountsGroupMW/ManageGameAccountsGroupMW.module.scss';

export const renderLauncherOptions = (
  item: ISelectOption<ELauncher>
): JSX.Element | null => {
  const Icon = ICONS[item.value];

  if (!Icon) return null;

  return (
    <span className={s.option}>
      <Icon size="m" />
      {item.title}
    </span>
  );
};
